import React from "react";
import { BarChart, CartesianGrid, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend } from "recharts";
import Title from "./Title";
import useTicketTracking from "../../hooks/useTicketTracking";

const STATUS_LABELS = { pending: "Pendiente", open: "Abierto", closed: "Cerrado", unknown: "Desconocido" };

const TrackingBarChart = ({ data, color, title }) => (
  <div className="bg-white dark:bg-slate-900/40 rounded-2xl border border-slate-100 dark:border-slate-800 p-5 h-full backdrop-blur-md shadow-sm flex flex-col">
    <Title>{title}</Title>
    <div className="w-full h-60 relative">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 15, left: -10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" className="dark:stroke-slate-800" />
          <XAxis type="number" stroke="#94a3b8" tick={{ fontSize: 11 }} />
          <YAxis dataKey="name" type="category" width={100} tick={{ fontSize: 11 }} stroke="#94a3b8" />
          <Tooltip
            contentStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              fontSize: "11px",
              color: "#1e293b"
            }}
          />
          <Bar dataKey="minutes" fill={color} name="Minutos" barSize={16} radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

const TicketsTrackingChart = ({ startDate, endDate, userId } = {}) => {
  const { data, loading } = useTicketTracking({ startDate, endDate, userId });

  if (loading) {
    return (
      <div className="flex items-center justify-center h-48 text-sm text-slate-400">
        <div className="w-6 h-6 border-2 border-indigo-650 border-t-transparent rounded-full animate-spin mr-2" />
        Analizando tiempos de transición...
      </div>
    );
  }

  const statusData = data.averageStatus.map((s) => ({
    name: STATUS_LABELS[s.status] || s.status,
    minutes: s.avgMinutes,
    count: s.count,
  }));

  const queueData = data.averageQueue.map((q) => ({
    name: q.queue,
    minutes: q.avgMinutes,
    count: q.count,
  }));

  const transitionData = (data.averageTransitions || []).map((t) => ({
    name: t.transition,
    minutes: t.avgMinutes,
    count: t.count,
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
      <TrackingBarChart data={statusData} color="#6366f1" title="Tiempo Promedio por Estado (min)" />
      <TrackingBarChart data={queueData} color="#10b981" title="Tiempo Promedio por Departamento (min)" />
      <TrackingBarChart data={transitionData} color="#f59e0b" title="Tiempo de Transición de Estados (min)" />
    </div>
  );
};

export default TicketsTrackingChart;

